/*
 * @Author: your name
 * @Date: 2020-11-11 16:32:12
 * @LastEditTime: 2020-11-12 14:37:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/home.js
 */
import request from "@/utils/request";
// 首页主题清单信息
export async function retailHomepage(params) {
  const url = `/api/front/product/retailHomepage/retailHomepage`;
  return request(url, { params });
}
// 首页小店信息
export async function findStoreByCondition(params) {
  const url = "/api/front/store/findStoreByCondition";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 主题清单详情列表
export async function queryRetailStoreThemeDetail(params) {
  const url = `/api/front/product/retailStoreTheme/queryRetailStoreThemeDetail/${params.id}?slug=${params.slug}`;
  return request(url);
}
